import { Component, OnInit, ViewChild, OnDestroy, AfterViewInit } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';

/*Services*/
import { StateService, ScreenService, DevicesService, CachedDataService, AppService } from '@services';

/*Models*/
import { DeviceState, Device } from '@models';

/*Plugin*/
import { Chart, Highcharts } from 'angular-highcharts';
import { IMyDrpOptions, IMyDateRangeModel } from 'mydaterangepicker';
import { OwlCarousel } from 'ngx-owl-carousel';
import * as moment from 'moment';
declare var $: any;

/*Config*/
import { CONFIG } from '../../config';


@Component({
  selector: 'app-state',
  templateUrl: './state.component.html',
  styleUrls: ['./state.component.css']
})

export class StateComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('owlTabGraph') owlTabGraph: OwlCarousel;
  chart: Chart;
  fromDate: any;
  toDate: any;
  charts;
  selectedChart;
  state: DeviceState;
  public isLoadData = false;
  public currentDevice: Device;
  private currentDate: any;
  private maxRangeDay = 30;
  public ifHasChartResult = false;
  public sliderChartsTabOptions: any;
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  public myDateRangePickerOptions: IMyDrpOptions = {
    dateFormat: 'dd.mm.yyyy',
    selectBeginDateTxt: 'Выберите начало периода',
    selectEndDateTxt: 'Выберите конец периода',
    showSelectDateText: true,
    monthSelector: true,
    showClearDateRangeBtn: false,
    editableDateRangeField: false,
    openSelectorOnInputClick: true,
    showClearBtn: false,
    showApplyBtn: false,
    yearSelector: false,
    disableSince: { year: 0, month: 0, day: 0 },
    dayLabels: CONFIG.dayLabels,
    monthLabels: CONFIG.monthLabels
  };

  public modelDateRange: any = {
    beginDate: { year: 2018, month: 7, day: 9 },
    endDate: { year: 2018, month: 7, day: 19 }
  };

  constructor(
    private devicesService: DevicesService,
    private stateService: StateService,
    private screenService: ScreenService,
    private cachedDataService: CachedDataService,
    private appService: AppService) {

    Highcharts.setOptions({
      lang: {
        shortMonths: [
          'янв', 'фев', 'мар', 'апр',
          'мая', 'июня', 'июля', 'авг',
          'сен', 'окт', 'ноя', 'дек'
        ]
      }
    });

    this.charts = [
      { type: 'voltage', title: 'Напряжение', units: 'V', id: 'voltage' },
      { type: 'fuel', title: 'Топливо', units: 'Л', id: 'fuel' },
      { type: 'reserved', title: 'Доп. питание', units: 'V', id: 'reservedVoltage' },
      { type: 'balance', title: 'Баланс', units: 'Р', id: 'balance' },
      { type: 'cJ', title: 't двигателя', units: '℃', id: 'temperatureEngine' },
      { type: 'cC', title: 'Пробег', units: 'Км', id: 'mileage' },
      { type: 'cH', title: 'Обороты', units: 'Rpm', id: 'rpm' },
    ];

    this.sliderChartsTabOptions = {
      dots: false,
      navigation: true,
      nav: true,
      navText: ['', ''],
      navClass: ['car-details-tabs-prev', 'car-details-tabs-next'],
      loop: false,
      lazyLoad: false,
      responsive: {
        0: { items: 3 },
        600: { items: 3 },
        1000: { items: 3 }
      }
    };

    this.stateService.currentDeviceObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(device => {
        this.currentDevice = device;
        if (this.currentDevice.provider.toLowerCase() === 'magicsystems') {
          if (this.currentDevice.deviceType !== 'beacon') {
            this.initGraph();
          }
        }
      });
    this.stateService.stateObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(state => {
        this.state = state;
        this.screenService.isDataLoadingSubject.next(false);
      });

    this.screenService.isDataLoadingObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(value => {
        this.isLoadData = value;
      });
  }

  ngOnInit() {
    this.stateService.autoUpdatePositionSubject.next(true);
    this.screenService.isStateHidden = false;
  }

  ngAfterViewInit() {
    const that = this;
    $(document).on('click', '.car-ind-list .item.cursor', (event) => {
      if (event.target.dataset.id) {
        that.showGraphState(event.target.dataset.id);
      }
    });
  }

  initGraph() {
    this.selectedChart = this.charts[0];
    const currentMoment = moment();
    this.fromDate = { date: { year: currentMoment.year(), month: currentMoment.month() + 1, day: currentMoment.date() } };
    this.toDate = { date: { year: currentMoment.year(), month: currentMoment.month() + 1, day: currentMoment.date() } };
    this.updateChart(this.fromDate.date, this.toDate.date);
    this.initDateRange();
  }

  checkIfStateHasGraph(id) {
    if (this.currentDevice.provider.toLowerCase() === 'magicsystems') {
      return this.charts.filter(chart => chart.id === id).length;
    } else {
      return false;
    }
  }

  showGraphState(id) {
    if (this.checkIfStateHasGraph(id) && this.owlTabGraph) {
      this.owlTabGraph.to([this.charts.indexOf(this.charts.filter(chart => chart.id === id)[0]), 200]);
      this.updatedSelectedChart(this.charts.filter(chart => chart.id === id)[0]);

    }
  }

  private initDateRange() {
    const date = new Date();
    this.currentDate = {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate(),
    };
    this.modelDateRange.beginDate = this.currentDate;
    this.modelDateRange.endDate = this.currentDate;
    this.onDateRangeChanged();
  }

  onDateRangeChanged(event?: IMyDateRangeModel) {
    const copy = this.getCopyOfOptions();
    copy.disableSince = {
      year: this.currentDate.year,
      month: this.currentDate.month,
      day: this.currentDate.day + 1
    };
    this.myDateRangePickerOptions = copy;
    if (event) {
      this.fromDate.date = event.beginDate;
      this.toDate.date = event.endDate;
      this.updateChart(event.beginDate, event.endDate);
    }

  }

  onDateSelected(event) {
    const selectedDay = new Date(event.date.year, event.date.month - 1, event.date.day);
    const nowDate = new Date();
    const delta = nowDate.getTime() - selectedDay.getTime();
    const deltaDay = Math.floor(delta / 1000 / 60 / 60 / 24);
    const copy = this.getCopyOfOptions();
    if (deltaDay < (this.maxRangeDay - 1)) {
      const date = this.addDays(selectedDay, deltaDay + 1);
      copy.disableSince = {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
      };
    } else {
      copy.disableSince = {
        year: event.date.year,
        month: event.date.month,
        day: event.date.day + this.maxRangeDay
      };
    }
    this.myDateRangePickerOptions = copy;
  }


  updatedSelectedChart(chart?) {
    this.selectedChart = chart;
    this.updateChart(this.fromDate.date, this.toDate.date);
    this.showChart(true);
  }

  updateChart(fromDate, toDate) {

    const userDateTimeOffset = this.appService.userTimezoneOffset();

    const fromMoment = moment.utc({ year: fromDate.year, month: fromDate.month - 1, date: fromDate.day });
    const toMoment = moment.utc({ year: toDate.year, month: toDate.month - 1, date: toDate.day });

    const from = fromMoment.startOf('day').subtract(userDateTimeOffset, 'h').unix();
    const to = toMoment.endOf('day').subtract(userDateTimeOffset, 'h').unix();

    this.devicesService.getHistory(this.currentDevice.id, this.selectedChart.type, from, to).subscribe(result => {
      this.screenService.isDataLoadingSubject.next(false);
      if (result.length) {
        this.ifHasChartResult = true;

        const data = result.map(statItem => [(statItem.time + (userDateTimeOffset * 60 * 60)) * 1000, parseFloat(statItem.value.toString().replace(",",".")) ]);

        this.showChart(data);
      } else {
        this.ifHasChartResult = false;
      }

    });
  }

  showChart(data) {
    const selectedChart = this.selectedChart;
    this.chart = new Chart({
      chart: {
        type: 'area'
      },
      tooltip: {
        formatter: function () {
          return Highcharts.dateFormat('%e %b %Y %H:%M', this.x) + '<br/>' +
            this.series.name + ', <b>' + this.y + ' ' + selectedChart.units + '</b>';
        }
      },
      plotOptions: {
        area: {
          fillColor: {
            linearGradient: {
              x1: 0,
              y1: 0,
              x2: 0,
              y2: 1
            },
            stops: [
              [0, Highcharts.getOptions().colors[0]]
            ]
          },
          marker: {
            radius: 2
          },
          lineWidth: 1,
          states: {
            hover: {
              lineWidth: 3
            }
          },
          threshold: null
        }
      },
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
          day: '%e %b'
        }
      },
      yAxis: {
        title: { text: '' }
      },
      title: { style: { 'display': 'none' } },
      credits: {
        enabled: false
      },
      legend: {
        enabled: false
      },
      series: [
        {
          name: this.selectedChart.title,
          data: data
        }
      ]
    });

  }

  getCopyOfOptions(): IMyDrpOptions {
    return JSON.parse(JSON.stringify(this.myDateRangePickerOptions));
  }
  addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}




// WEBPACK FOOTER //
// ./src/app/view/state/state.component.ts